// Tremor Card [v1.0.0]

import { Slot } from '@radix-ui/react-slot'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'

import { cn } from '#app/utils/misc.tsx'

interface CardProps extends ComponentPropsWithoutRef<'div'> {
	asChild?: boolean
}

const Card = forwardRef<HTMLDivElement, CardProps>(
	({ className, asChild, ...props }, forwardedRef) => {
		const Component = asChild ? Slot : 'div'
		return (
			<Component
				ref={forwardedRef}
				className={cn(
					// base
					'relative w-full rounded-lg border p-6 text-left',
					// background color
					'bg-white dark:bg-[#090E1A]',
					// border color
					'border-gray-200 dark:border-gray-900',
					className,
				)}
				tremor-id="tremor-raw"
				{...props}
			/>
		)
	},
)

Card.displayName = 'Card'

export { Card, type CardProps }
